package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.AuthRepository
import fr.manyverse.app.domain.validation.EmailValidator

class SendOtpUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(email: String): Result<Unit> {
        EmailValidator.validate(email).onFailure {
            return Result.failure(it)
        }
        return authRepository.sendOtpToEmail(email)
    }
}
